import _slicedToArray from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\dotsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
import './HeroSecondary.css';
import React, { useState, useEffect } from 'react';
import { canUseDOM, get, getColorByTheme, getPageThemeColors, injectImageResolution } from '../../utils';
import { Text } from '@sitecore-jss/sitecore-jss-react';
import { SitecoreContextReactContext } from '../../utils/SitecoreContextReactContext';
import ComponentsWrapper from '../atoms/ComponentsWrapper';
import LazyPicture from '../atoms/LazyPicture';
/* import { tealiumClickFunc } from '../../utils/tealium'; */

import RouterLink from '../atoms/RouterLink';
import { tealiumClickFunc, tealiumMergeClickData } from '../../utils/tealium';
import { convertToAnalyticObject } from '../../utils/analytics';
var HeroSecondary = function HeroSecondary(props) {
  var sitecoreContext = React.useContext(SitecoreContextReactContext);
  var fields = props.fields,
    params = props.params;
  /* const rtl: boolean = Boolean(sitecoreContext && sitecoreContext.rtl); */
  var pageEditing = Boolean(sitecoreContext && sitecoreContext.pageEditing);
  var _useState = useState(true),
    _useState2 = _slicedToArray(_useState, 2),
    isVdsite = _useState2[0],
    setIsVdsite = _useState2[1];
  var src = get(fields, 'data.item.image.jss.value.src', '');
  var alt = get(fields, 'data.item.image.jss.value.alt', '');
  var title = get(fields, 'data.item.title.jss');
  var hasTitle = get(fields, 'data.item.title.jss.value');
  var intro = get(fields, 'data.item.description.jss');
  var hasIntro = get(fields, 'data.item.description.jss.value');
  var primaryCtaHref = get(fields, 'data.item.cTALink.jss.value.href');
  var primaryCtaLabel = get(fields, 'data.item.cTALinkLabel.jss.value');
  var primaryCtaTarget = get(fields, 'data.item.cTALink.jss.value.target');
  var primaryCtaLinktype = get(fields, 'data.item.cTALink.jss.value.linktype');
  useEffect(function () {
    if (canUseDOM && !document.body.classList.contains('vdsite')) {
      setIsVdsite(false);
    }
  }, []);
  var BackgroundColorHex = get(params, 'BackgroundColorHex');
  var ColorHex = get(params, 'ColorHex');
  var ActiveColorHex = get(params, 'ActiveColorHex');
  var primaryPageThemeColor = get(sitecoreContext, 'themesOfPage.primary');
  var primaryActivePageThemeColor = get(sitecoreContext, 'themesOfPage.primary_active');
  var selectedPrimaryColor = primaryPageThemeColor ? primaryPageThemeColor : getPageThemeColors(isVdsite).primary;
  var eventsAnalytics = get(fields, 'data.eventsAnalytics') || [];
  if (eventsAnalytics.length) {
    eventsAnalytics = convertToAnalyticObject(eventsAnalytics);
  }
  var variables = BackgroundColorHex ? {
    "--m57-hero-secondary-background-color": BackgroundColorHex,
    "--m57-hero-secondary-background-active-color": ActiveColorHex,
    "--m57-hero-secondary-color": ColorHex
  } : {
    "--m57-hero-secondary-background-color": selectedPrimaryColor,
    "--m57-hero-secondary-background-active-color": primaryActivePageThemeColor ? primaryActivePageThemeColor : getPageThemeColors(isVdsite).primary_active,
    "--m57-hero-secondary-color": getColorByTheme(selectedPrimaryColor)
  };
  if (!fields) {
    console.info('Hero component render skipped. No fields provided');
    if (pageEditing) {
      return /*#__PURE__*/React.createElement("div", {
        className: "no-data"
      }, " [Hero component is empty: please provide data source]");
    }
    return null;
  }
  return /*#__PURE__*/React.createElement(ComponentsWrapper, {
    anchorUrlParameter: params['Anchor Url Parameter'],
    className: src ? commonStyles : commonStylesWithoutImage,
    style: _objectSpread({}, variables),
    fullWidth: true
  }, function () {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "hero"
    }, src && /*#__PURE__*/React.createElement(LazyPicture, {
      className: "hero-secondary-image"
    }, /*#__PURE__*/React.createElement("source", {
      media: "(min-width: 992px)",
      srcSet: "".concat(injectImageResolution(src, 1920, 888))
    }), /*#__PURE__*/React.createElement("img", {
      src: "".concat(injectImageResolution(src, 750, 1164)),
      alt: alt,
      className: "slider__image"
    })), /*#__PURE__*/React.createElement("div", {
      className: "texts"
    }, hasTitle && /*#__PURE__*/React.createElement(Text, {
      tag: "h1",
      className: "title",
      field: title
    }), hasIntro && /*#__PURE__*/React.createElement(Text, {
      tag: "p",
      className: "intro",
      field: intro
    }), primaryCtaHref && primaryCtaLabel && /*#__PURE__*/React.createElement(RouterLink, {
      href: primaryCtaHref,
      className: "btn btn-secondary btn-secondary-mono",
      title: primaryCtaLabel,
      linksTarget: primaryCtaTarget,
      linktype: primaryCtaLinktype,
      onClick: function onClick() {
        return tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['ctaButtonAnalytics'], params), [hasTitle, primaryCtaLabel]);
      }
    }, primaryCtaLabel))));
  });
};
var commonStyles = "cbxrlk6";
var commonStylesWithoutImage = "c1edly01";
export default HeroSecondary;